import { render, staticRenderFns } from "./mokuai36.vue?vue&type=template&id=98d5be1a&"
import script from "./mokuai36.vue?vue&type=script&lang=js&"
export * from "./mokuai36.vue?vue&type=script&lang=js&"
import style0 from "./mokuai36.vue?vue&type=style&index=0&id=98d5be1a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports